module.exports = __webpack_public_path__ + "static/media/parque.cd964129.png";